<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="media-monitor-settings">
      <el-form
        ref="form"
        :model="formdata"
        :rules="rules"
        label-width="170px"
      >
        <el-form-item
          label="监控开启状态："
          prop="State"
        >
          <el-switch
            active-color="#13ce66"
            v-model="formdata.State"
          ></el-switch>
        </el-form-item>
        <el-form-item
          label="昨日活动访问UV ≤："
          prop="YesterdayUV"
          :required="formdata.State"
        >
          <el-input
            size="small"
            type="number"
            v-model.number="formdata.YesterdayUV"
          ></el-input>
        </el-form-item>
        <el-form-item
          :required="formdata.State"
          label="今日活动访问UV ≥："
          prop="TodaydayUV"
        >
          <el-input
            size="small"
            type="number"
            v-model.number="formdata.TodaydayUV"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="抄送人邮箱："
          prop="Email"
        >
          <div class="email-box">
            <el-tag
              :key="tag"
              v-for="tag in formdata.Email"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{tag}}
            </el-tag>
            <el-input
            size="small"
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              size="small"
              class="button-new-tag"
              @click="showInput"
            >+</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-tooltip
            :disabled="inputVisible"
            content="Top center"
            placement="请输入正确的邮箱或者清空错误的邮箱"
          >
          <span>
             <el-button
            size="small"
            :disabled="inputVisible"
            type="primary"
            @click="saveInfo('form')"
          >保 存</el-button>
          </span>

          </el-tooltip>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
// api
import { GetMediaEmailList, SaveMediaEmailList } from "api/settingSystem";

export default {
  data() {
    var validateActualAmount = (rule, value, callback) => {
      if (this.formdata.State) {
        if (value === "") {
          callback(new Error("输入不能为空"));
          return;
        } else {
          setTimeout(() => {
            if (isNaN(value)) {
              callback(new Error("请输入数字值"));
            } else {
              if (value <= 0) {
                callback(new Error("请输入大于零的整数"));
              } else {
                var checkvalue = value.toString();
                if (checkvalue.split(".").length >= 2) {
                  var num = checkvalue.split(".")[1].split("");
                  if (num.length > 0) {
                    callback(new Error("请输入整数"));
                  } else {
                    callback();
                  }
                } else {
                  callback();
                }
              }
            }

            // }
          }, 500);
        }
      } else {
        callback();
      }
    };
    return {
      formdata: {
        State: false,
        YesterdayUV: "",
        TodaydayUV: "",
        Email: []
      },
      inputVisible: false,
      inputValue: "",
      rules: {
        YesterdayUV: [
          { validator: validateActualAmount, trigger: ["blur", "change"] }
        ],
        TodaydayUV: [
          { validator: validateActualAmount, trigger: ["blur", "change"] }
        ]
      },
      // 面包屑参数
      trails: [
        {
          trail: "系统设置",
          href: ""
        },
        {
          trail: "媒体监控设置",
          href: ""
        }
      ]
    };
  },
  computed: {},
  components: {
    // 面包屑
    crumbs
  },
  methods: {
    getInfo() {
      GetMediaEmailList().then(res => {
        if (res) {
          var getData = JSON.parse(res);
          this.formdata.State = getData.State ? true : false;
          this.formdata.YesterdayUV = getData.YesterdayUV;
          this.formdata.TodaydayUV = getData.TodaydayUV;
          this.formdata.Email = getData.Email || [];
        }
      });
    },
    saveInfo(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.formdata.State = this.formdata.State ? 1 : 0;
          SaveMediaEmailList(this.formdata).then(res => {
            this.getInfo();
            if (res.Success) {
              this.$message({
                message: "保存成功",
                type: "success"
              });
            } else {
              this.$message({
                message: "保存失败",
                type: "error"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose(tag) {
      var that = this;
      this.$confirm(`确定要删除邮箱 [${tag}] 吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.formdata.Email.splice(this.formdata.Email.indexOf(tag), 1);
        })
        .catch(() => {});
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        inputValue = inputValue.toLowerCase();
        var reg = new RegExp(
          "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
        );
        if (!reg.test(inputValue)) {
          this.$message({
            message: "邮箱格式不正确，请输入正确的邮箱",
            type: "warning"
          });
          return;
        }
        console.log(this.formdata.Email.indexOf(inputValue.trim()));
        if (this.formdata.Email.indexOf(inputValue.trim()) != -1) {
          this.$message({
            message: "邮箱重复，请重新输入",
            type: "warning"
          });
          return;
        }
        this.formdata.Email.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    }
  },
  created() {
    document.title = "媒体监控设置";
  },
  mounted() {
    this.getInfo();
  }
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}
ul.nav {
  padding: 0 !important;
}
#navbar .sign-in-wrap {
  padding-right: 50px !important;
}
.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}
#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}
.money-icon {
  margin-right: 5px !important;
}
.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}
.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}
.putonArea .region {
  margin-top: 4px !important;
}
.putonArea .region .provinces-group {
  width: 650px !important;
}
.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}
.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}
.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}
.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss" scoped>
@import "../../common/scss/color.scss";
.media-monitor-settings {
  padding-left: 20px;
  .el-form-item {
    vertical-align: middle;
    .email-box {
      display: inline-block;
      padding: 3px;
      border: 1px solid #dfdfdf;
      .el-input {
        height: 26px;
      }
      .el-button {
        padding: 6px 15px;
        border: none;
        font-size: 14px;
        font-weight: 700;
        vertical-align: middle;
      }
      .el-tag {
        height: 24px;
        vertical-align: middle;
        line-height: 24px;
        font-size: 14px;
      }
      .el-input {
        width: 200px;
      }
    }
    .el-switch {
      margin-top: 11px;
    }
  }
  .el-input {
    width: 10%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system-settings/media-monitor-settings.vue